/**
 * Buy Bonus Popup
 */
buyBonusPopup = {};
buyBonusPopup.infoText = undefined;
buyBonusPopup.open = false;

buyBonusPopup.show = function (callback) {

  buyBonusPopup.open = true;

  // buyBonusPopup.showTimeline.play(0);

  buyBonusPopup.yesButton.enableButton(true);
  buyBonusPopup.noButton.enableButton(true);

  messageBus.post("game:modal", { reason: "buy_bonus" });
  
  let stakeController = resourceManager.getController("stakeController");
  buyBonusPopup.currentStakeIndex = buyBonusPopup.getInitialStakeIndex();
  if (buyBonusPopup.infoText !== undefined) {
    let text = buyBonusPopup.infoText._text;
    if (text.includes("12")) {
      text = text.replace("12", "8");
      buyBonusPopup.infoText.setText(text);
    }
  }

  buyBonusPopup.updatePopup();

  buyBonusPopup.container.visible = true;
  buyBonusPopup.callback = callback;
};

buyBonusPopup.getInitialStakeIndex = function () {
  let stakeController = resourceManager.getController("stakeController");
  let currentStake = stakeController.CurrentStake;
  let bonusBuyStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY._nonMultipliedStakes;

  let index = bonusBuyStakes.indexOf(currentStake);
  return index !== -1 ? index : bonusBuyStakes.length - 1;
}

buyBonusPopup.updatePopup = function () {
  if (buyBonusPopup.currentStakeIndex === -1) {
    buyBonusPopup.stakePreviousButton.enableButton(false);
    buyBonusPopup.stakeNextButton.enableButton(false);
    buyBonusPopup.yesButton.enableButton(false);
  } else {
    const bonusBuyStakes =
      buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY.coinSizes;

    buyBonusPopup.stakePreviousButton.enableButton(
      buyBonusPopup.currentStakeIndex > 0
    );
    buyBonusPopup.stakeNextButton.enableButton(
      buyBonusPopup.currentStakeIndex < bonusBuyStakes.length - 1
    );

    let baseStake = buyBonusPopup.convertToTotalStake(
      bonusBuyStakes[buyBonusPopup.currentStakeIndex]
    );
    buyBonusPopup.baseStakeText.setText(gdk.formatCurrency(baseStake));

    let cost = baseStake * buyBonusPopup.gameConfig.data.buyBonusCost;
    buyBonusPopup.betValueText.setText(gdk.formatCurrency(cost));
    buyBonusPopup.yesButton.enableButton(buyBonusPopup.balance >= cost);
  }
};

buyBonusPopup.create = function (json) {
  return new PIXI.Container();
};

buyBonusPopup.convertToTotalStake = function (coinSize) {
  let stakeController = resourceManager.getController("stakeController");
  return coinSize * stakeController.CurrentWinLineCount;
};

buyBonusPopup.onStakeNextPressed = function () {
  const bonusBuyStakes =
    buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY.coinSizes;
    buyBonusPopup.currentStakeIndex = Math.min(
    buyBonusPopup.currentStakeIndex + 1,
    bonusBuyStakes.length - 1
  );
  buyBonusPopup.updatePopup();

  soundManager.play("buttonPressed");
};

buyBonusPopup.onStakePreviousPressed = function () {
  buyBonusPopup.currentStakeIndex = Math.max(
    buyBonusPopup.currentStakeIndex - 1,
    0
  );
  buyBonusPopup.updatePopup();

  soundManager.play("buttonPressed");
};

buyBonusPopup.initialise = function (json, container) {
  buyBonusPopup.container = container;
  buyBonusPopup.container.visible = false;

  buyBonusPopup.fadedMask = new PIXI.Graphics();
  buyBonusPopup.fadedMask.beginFill(0, 0.8);
  buyBonusPopup.fadedMask.drawRect(-10000, -10000, 20000, 20000);
  buyBonusPopup.fadedMask.endFill();
  buyBonusPopup.container.addChild(buyBonusPopup.fadedMask);

  messageBus.subscribe("spinner:GameConfigEvent", buyBonusPopup.onGameConfig);
  messageBus.subscribe("common:BalanceEvent", buyBonusPopup.onBalanceEvent);
  messageBus.subscribe("game:modal", buyBonusPopup.onModal);
  Reflex.registerEventHandler(
    "orientationChange",
    buyBonusPopup.orientationChange
  );

  buyBonusPopup.helpActive = false;
};

buyBonusPopup.onModal = function (data) {
  if (buyBonusPopup.container.visible) {
    if (data.reason && data.reason === "Options menu open") {
      buyBonusPopup.helpActive = true;

      buyBonusPopup.yesButton.enableButton(false);
      buyBonusPopup.noButton.enableButton(false);

      buyBonusPopup.stakePreviousButton.enableButton(false);
      buyBonusPopup.stakeNextButton.enableButton(false);
    } else if (buyBonusPopup.helpActive || data.reason === "help menu closed") {
      buyBonusPopup.helpActive = false;

      buyBonusPopup.yesButton.enableButton(true);
      buyBonusPopup.noButton.enableButton(true);

      buyBonusPopup.updatePopup();
    }

    if (buyBonusPopup.open) {
      if (data.reason === undefined) {
        messageBus.post("game:modal", { reason: "buy_bonus" });
      }
    }
  }
};

buyBonusPopup.init = function () {
  buyBonusPopup.background = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground"
  );

  buyBonusPopup.yesButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:yesButton"
  );
  buyBonusPopup.yesButton.onPressedCallback = buyBonusPopup.onClickedYes;

  buyBonusPopup.noButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:noButton"
  );
  buyBonusPopup.noButton.onPressedCallback = buyBonusPopup.onClickedNo;

  buyBonusPopup.stakePreviousButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:stakePrevious"
  );
  buyBonusPopup.stakePreviousButton.onPressedCallback =
    buyBonusPopup.onStakePreviousPressed;

  buyBonusPopup.stakeNextButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:stakeNext"
  );
  buyBonusPopup.stakeNextButton.onPressedCallback =
    buyBonusPopup.onStakeNextPressed;

  buyBonusPopup.baseStakeText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:baseStakeText"
  );

  buyBonusPopup.infoText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:infoText"
  );

  buyBonusPopup.betValueText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:buyBonusHintValue"
  );

  const border = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:canvas"
  );
};

buyBonusPopup.onClosePopup = function (buyBonus) {
  soundManager.play("buttonPressed");

  buyBonusPopup.open = false;

  if (buyBonus) {
    buyBonusPopup.container.visible = false;

    buyBonusPopup.callback(buyBonus);

    buyBonusPopup.onStartBonusSpin();
  } else {
    buyBonusPopup.container.visible = false;

    buyBonusPopup.callback(buyBonus);

    messageBus.post("game:modal", {});
  }
};

buyBonusPopup.onBalanceEvent = function (event) {
  buyBonusPopup.balance = event.data.balance;
};

buyBonusPopup.onStartBonusSpin = function () {
  gameData.winningsMeter.set(0);
  let stakeController = resourceManager.getController("stakeController");

  gameController.inBuyABonus = true;

  messageBus.post("game:modal", {});

  const bonusBuyStakes =
    buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY.coinSizes;
  let baseStake = buyBonusPopup.convertToTotalStake(
    bonusBuyStakes[buyBonusPopup.currentStakeIndex]
  );
  stakeController.requestChangeStake(baseStake, "BONUS_BUY");
  gameController.updateStake();

  var bpl = baseStake / stakeController.CurrentWinLineCount;

  gdk.startGame(
    {
      stake: baseStake * buyBonusPopup.gameConfig.data.buyBonusCost,
      numWinlines: stakeController.CurrentWinLineCount,
      bpl: bpl,
      metaData: {
        encore: gameData.encoreEnabled,
        buyABonus: true,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

buyBonusPopup.orientationChange = function () {
};

buyBonusPopup.onGameConfig = function (event) {
  buyBonusPopup.gameConfig = event;
  buyBonusPopup.init();
};

buyBonusPopup.onClickedYes = function () {
  buyBonusPopup.onClosePopup(true);
};

buyBonusPopup.onClickedNo = function () {
  buyBonusPopup.open = false;

  messageBus.post("game:modal", {});

  buyBonusPopup.onClosePopup(false);
};

buyBonusPopup.onInfo = function () {
  soundManager.play("buttonPressed");
  gameData.helpPageScroll.open();
};

buyBonusPopup.getFilesRequired = function (json) {
  return [];
};

resourceManager.registerObjectType(
  "buyBonusPopup",
  buyBonusPopup.create,
  buyBonusPopup.initialise,
  buyBonusPopup.getFilesRequired
);
